import axios from 'axios'
import { API_BASE_URL, API_TIMEOUT } from './config'
import store from '@/store'
// import { useRouter } from 'vue-router'

// const MOCK_ENABLED = process.env.NODE_ENV === 'development'

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(config => {
  const token = store.state.user.token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 响应拦截器
// api.interceptors.response.use(
//   response => response.data,
//   error => {
//     // 处理mock请求
//     if (MOCK_ENABLED && error.config.url.includes('/auth/register')) {
//       // 模拟密码太短
//       if (JSON.parse(error.config.data).password.length < 6) {
//         return Promise.reject({
//           message: '密码至少需要6位字符'
//         })
//       }
//       // 模拟邮箱已存在
//       if (JSON.parse(error.config.data).email === 'exists@test.com') {
//         return Promise.reject({
//           message: '该邮箱已被注册'
//         })
//       }
//     }
//     if (error.response) {
//       const { status } = error.response
//       if (status === 401) {
//         store.dispatch('user/logout')
//         const router = useRouter()
//         router.push('/login')
//       }
//       return Promise.reject(error.response.data)
//     }
//     return Promise.reject({ message: '网络连接错误' })
//   }
// )

export default api 